import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiClickTodayButton]',
})
export class ClickTodayButtonDirective {
  @Output() clickTodayButton = new EventEmitter();

  @HostListener('click', ['$event']) onClick(e: MouseEvent) {
    if (
      e.target instanceof HTMLElement &&
      (e.target.classList.contains('k-calendar-nav-today') ||
        e.target.classList.contains('k-calendar-nav') ||
        e.target.parentElement.classList.contains('k-calendar-nav-today'))
    ) {
      this.clickTodayButton.emit();
    }
  }
}
